import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { Helmet } from "react-helmet-async"; // <-- Ajout de Helmet pour le SEO
import API from "../services/api";
import "../styles/AuthPages.css";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // État pour basculer la visibilité

  const navigate = useNavigate();

  const login = async () => {
    try {
      const response = await API.post("/users/login", { email, password });

      // Stockage propre des informations
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("role", response.data.user.role);
      localStorage.setItem("user", JSON.stringify(response.data.user));

      alert("Connexion réussie ✅");
      
      // Redirection fluide
      navigate("/profile");
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
        "Erreur de connexion"
      );
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    const res = await API.post("/users/google", {
      credential: credentialResponse.credential
    });

    localStorage.setItem("token", res.data.token);
    localStorage.setItem("user", JSON.stringify(res.data.user));

    window.location.href = "/profile";
  };

  return (
    <div className="auth-page">
      {/* --- BLOC REFERENCEMENT / SEO --- */}
      <Helmet>
        <title>Connexion - Accédez à FootVision Live</title>
        <meta name="description" content="Connectez-vous à votre espace FootVision pour retrouver vos matchs favoris, vos alertes en direct et vos pronostics personnalisés." />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Se connecter – FootVision Live" />
        <meta property="og:description" content="Accédez à votre tableau de bord et à vos analyses de football." />
        <meta property="og:url" content="https://www.footvisionlive.com/login" />
        <meta property="og:image" content="https://www.footvisionlive.com/logo1.png" />
        <meta name="robots" content="noindex, nofollow" /> {/* Protège la page contre le crawl public inutile */}
      </Helmet>

      <div className="auth-card">
        <GoogleLogin 
          onSuccess={handleGoogleSuccess}
          onError={() => console.log("Erreur Google")}
          style={{
            background: "var(--white)",
            color: "var(--black)",
          }}
        />
        
        <h1>Connexion</h1>
        
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        
        <input
          type={showPassword ? "text" : "password"}
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {/* Ajout du bloc checkbox juste en dessous du mot de passe */}
        <div className="show-password-container">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={showPassword}
              onChange={() => setShowPassword(!showPassword)}
            />
            <span className="checkbox-text">Afficher le mot de passe</span>
          </label>
        </div>

        <div className="forgot-password">
          <span onClick={() => navigate("/forgot-password")} style={{ cursor: "pointer" }}>
            Mot de passe oublié ?
          </span>
        </div>

        <button onClick={login}>
          Se connecter
        </button>

        <div className="forgot-password">
          <span onClick={() => navigate("/register")} style={{ cursor: "pointer" }}>
            Vous n'avez pas un compte ? Inscrivez-vous
          </span>
        </div>

      </div>
    </div>
  );
}

export default LoginPage;